// extracted by mini-css-extract-plugin
export default {"categoriesForm":"LoyaltyProgramCategoryTemplate_categoriesForm__8bSUq"};